<template>
  <div class="clientele" >
    <el-divider content-position="left">通讯录</el-divider>
    <div class="header-con">
      <el-row class="mtb30 tr">
        <el-popconfirm title="确定更新吗？" @onConfirm="handleUp">
          <el-button size="mini" type="primary" slot="reference">更新部门</el-button>
        </el-popconfirm>
        <el-popconfirm title="确定更新吗？" @onConfirm="handleUser">
          <el-button size="mini" type="primary" slot="reference">更新成员</el-button>
        </el-popconfirm>
        <el-popconfirm title="确定更新吗？" @onConfirm="handleByUser">
          <el-button size="mini" type="primary" slot="reference">更新客户</el-button>
        </el-popconfirm>
      </el-row>
      <el-row class="m-con">
        <el-col class="user-list" :span="4">
          <el-input
            size="small"
            placeholder="搜索员工"
            suffix-icon="el-icon-search"
            v-model="search">
          </el-input>
          <div class="list">
            <el-tree
              class="filter-tree"
              accordion
              :data="departments"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @node-click="nodeClick"
              ref="tree">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <el-image v-if="data.thumb_avatar" :src="data.thumb_avatar" fit="fit" style="width: 20px; height: 20px; vertical-align: middle"></el-image>
                <span>{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
        </el-col>
        <el-col class="user-list" :span="4"></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {

      search: '',
      departments: [
        {
          id: 1,
          name: '部门一',
          children: [
            {
              id: 5,
              name: '章三'
            }
          ]
        },
        {
          id: 2,
          name: '部门二'
        },
        {
          id: 3,
          name: '部门三'
        }
      ],
      defaultProps: {
        children: 'employees',
        label: 'name'
      }
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    search (val) {
      console.log(val)
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    getDepartments () {
      this.$axios.get('/api/admin/departments')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.departments = data.data
          }
        })
    },
    handleUp () {
      this.$axios.post('/api/admin/departments/insert')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.departments = data.data
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    nodeClick (a, b, c) {
      console.log(a)
    },
    handleUser () {
      this.$axios.post('/api/admin/employees/insert')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.departments = data.data.departments
            this.$message.success(data.msg + '，失败：' + data.data.failure)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleByUser () {
      this.$axios.post('/api/admin/external/insert')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg + '，失败：' + data.data.failure)
          } else {
            this.$message.error(data.msg)
          }
        })
    }
  },
  mounted () {
    this.getDepartments()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .clientele
    marginLeft()
    .mtb30
      margin-bottom: .6rem
    .tr
      text-align: right
    .m-con
      background-color: #fff
      border-radius: .2rem .2rem 0 0
    .user-list
      min-height: calc(100vh - 210px)
      padding-right: 12px
      border-right: 1px solid #ebebeb
    .list
      margin-top: .3rem
</style>



// WEBPACK FOOTER //
// src/pages/conversation/Clientele.vue